export interface TaxStat {
  label: string;
  subtext: string;
  value: string;
  valueColor: string;
  iconBg: string;
  iconColor: string;
  badge?: { text: string; color: string; bg: string };
}

export interface ActivityItem {
  title: string;
  description: string;
  timestamp: string;
  source: string;
  dotColor: string;
}

export interface ComplianceAlert {
  title: string;
  subtext: string;
  bg: string;
  borderColor: string;
  titleColor: string;
}

export interface ExportAction {
  label: string;
  variant: 'primary' | 'secondary';
}

export const exportActions: ExportAction[] = [
  // Was mislabeled "(PDF)" while always generating a CSV; now backed by the
  // real server-side export (GET /tax-compliance/activity?format=csv), so
  // the label is corrected to match what it actually produces (Sec 12).
  { label: 'Download Tax Report (CSV)', variant: 'primary' },
  { label: 'Export CSV (State Filing Format)', variant: 'secondary' },
  { label: 'Export 1099 E-File Package', variant: 'secondary' },
];
